import React from 'react';
import { UUID } from '@/types';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { useQueryId, useSeriesId } from '@/hooks';
import {
  selectLastUpdateMethod,
  setLastUpdateMethod,
} from '@/features/query-builder-steps/queryBuilderStepsSlice';
import { LAST_UPDATE_METHOD } from '@/features/query-builder-steps/constants';

export const useSetLastUpdateMethodToLoaded = (
  currentQueryIdRef: React.MutableRefObject<Maybe<UUID>>,
) => {
  const dispatch = useAppDispatch();
  const queryId = useQueryId();
  const seriesId = useSeriesId();
  const lastUpdatedMethod = useAppSelector(selectLastUpdateMethod);

  React.useEffect(() => {
    const shouldSetBackendSyncForSavedQuery =
      seriesId && lastUpdatedMethod !== LAST_UPDATE_METHOD.saveQuery;
    const shouldSetBackendSyncForAdHocQuery =
      queryId && queryId !== currentQueryIdRef.current;

    if (
      shouldSetBackendSyncForSavedQuery ||
      shouldSetBackendSyncForAdHocQuery
    ) {
      dispatch(setLastUpdateMethod(LAST_UPDATE_METHOD.backendSync));
    }
  }, [queryId, seriesId]);
};
